// extracted by mini-css-extract-plugin
export default {"optionPadding":"ExactnessSingleSelect_optionPadding__Yqb9n"};